export default __webpack_public_path__ + "static/media/menu-people.efcc2393.svg";